import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=94b5c4f6&scoped=true&lang=pug&"
import script from "./Main.vue?vue&type=script&lang=js&"
export * from "./Main.vue?vue&type=script&lang=js&"
import style0 from "./Main.vue?vue&type=style&index=0&id=94b5c4f6&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94b5c4f6",
  null
  
)

/* custom blocks */
import block0 from "./Main.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports